import { _map, _controlers, config }  from '../map';
import * as preferences from '../preferences';
/**
 * This file adds Labels to the map
 */

export async function init() {
  console.log('[MAP/LABELS] init()');

  //loadLabels();
}

// function loadLabels() {
// 	fetch('data/labels.json')
// 		.then(response => {
// 			if(!response.ok) return []; // throw Error(response.statusText);
// 			return response.json();
// 		}).then(data => {
// 			for(let label of data) {
// 				// TODO: make these labels only appear at zoom level 3 or higher (>=200%)
// 				if(label.fontSize < 1) continue;
//
// 				let marker = L.textMarker([ label.y+0.5, label.x+0.5 ], label.text);
// 				_layer_labels.addLayer(marker);
// 			}
// 		});
// }
